import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LayoutDashboard, Store, Briefcase, CheckSquare, Users, Bell, Star, Receipt, UserCog } from "lucide-react";

export const EmployerTabs = () => {
  const { t } = useTranslation();
  const tabs = [
    { to: "/employer", icon: LayoutDashboard, label: t("employer.tabs.overview"), end: true },
    { to: "/employer/restaurants", icon: Store, label: t("employer.tabs.restaurants") },
    { to: "/employer/jobs", icon: Briefcase, label: t("employer.tabs.jobs") },
    { to: "/employer/applications", icon: CheckSquare, label: t("employer.tabs.applications") },
    { to: "/employer/candidates", icon: Users, label: t("employer.tabs.candidates") },
    { to: "/employer/notifications", icon: Bell, label: t("employer.tabs.notifications") },
    { to: "/employer/plans", icon: Star, label: t("employer.tabs.plans") },
    { to: "/employer/billing", icon: Receipt, label: t("employer.tabs.billing") },
    { to: "/employer/account", icon: UserCog, label: t("employer.tabs.account") },
  ];
  return (
    <div className="flex gap-1 overflow-x-auto no-scrollbar mb-6 border-b border-stone-border" data-testid="employer-tabs">
      {tabs.map((tab) => {
        const Icon = tab.icon;
        return (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            data-testid={`etab-${tab.to.split("/").pop() || "overview"}`}
            className={({ isActive }) =>
              `flex items-center gap-2 px-4 py-3 text-sm font-medium whitespace-nowrap border-b-2 -mb-px transition-colors ${
                isActive ? "border-brand text-brand" : "border-transparent text-stone-sub hover:text-brand"
              }`
            }
          >
            <Icon className="w-4 h-4" /> {tab.label}
          </NavLink>
        );
      })}
    </div>
  );
};
